import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

// On tenant systems. The card hides itself for anyone outside the tenant group.
export const clusterAccessModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityCardBlueprint.make({
      name: 'cluster-access',
      params: {
        filter: entity =>
          entity.kind === 'System' && (entity.metadata.tags ?? []).includes('tenant'),
        loader: async () =>
          import('./ClusterAccessCard').then(m => <m.ClusterAccessCard />),
      },
    }),
  ],
});
